// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__zWaPe","notes":"Notes_notes__2nHTg","note":"Notes_note__3uSee","markdown":"Notes_markdown__1wOh2"};